"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvitationLinkSection = exports.EmailFormSection = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _classnames = _interopRequireDefault(require("classnames"));

var Yup = _interopRequireWildcard(require("yup"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var _FormErrorMessage = _interopRequireDefault(require("../../../../components/FormErrorMessage"));

var _Button = _interopRequireDefault(require("../../../../components/Button"));

var _InputWithDomain = _interopRequireDefault(require("./InputWithDomain"));

var NewAccount = function NewAccount(_ref) {
  var isSuccess = _ref.isSuccess,
      children = _ref.children,
      onClose = _ref.onClose;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "text-2xl font-bold flex-1"
  }, !isSuccess ? t('settings.customDomain.newAccount.title') : t('settings.customDomain.newAccount.success')), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClose,
    className: "text-gray-medium hover:text-gray-light"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    fontSize: "large"
  }))), children);
};

var _default = NewAccount;
exports["default"] = _default;

var Section = function Section(_ref2) {
  var label = _ref2.label,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "my-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uppercase text-sm font-bold text-gray-medium my-2"
  }, label), children);
};

var EmailFormSection = function EmailFormSection(_ref3) {
  var _ref3$email = _ref3.email,
      email = _ref3$email === void 0 ? '' : _ref3$email,
      domain = _ref3.domain,
      _onSubmit = _ref3.onSubmit,
      isCreated = _ref3.isCreated,
      _ref3$isLoading = _ref3.isLoading,
      isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement(Section, {
    label: t('settings.customDomain.newAccount.email')
  }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      email: email.split('@')[0]
    },
    validationSchema: Yup.object({
      email: Yup.string().trim().test('valid-email', t('signup.form.email.invalid'), function (val) {
        try {
          Yup.string().email().validateSync("".concat(val || '', "@").concat(domain));
          return true;
        } catch (e) {
          return false;
        }
      }).required(t('required'))
    }),
    onSubmit: function onSubmit(values, formikBag) {
      return _onSubmit(values.email, formikBag);
    },
    render: function render(_ref4) {
      var handleSubmit = _ref4.handleSubmit,
          errors = _ref4.errors,
          dirty = _ref4.dirty;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex mb-2"
      }, /*#__PURE__*/_react["default"].createElement(_InputWithDomain["default"], {
        name: "email",
        domain: domain,
        disabled: isCreated || isLoading
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex items-center justify-center', {
          'w-40': !isCreated,
          'w-24': isCreated
        })
      }, isCreated ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-primary"
      }, /*#__PURE__*/_react["default"].createElement(_Check["default"], {
        fontSize: "large"
      })) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        className: "w-full",
        onClick: handleSubmit,
        disabled: !(0, _isEmpty["default"])(errors) || !dirty || isLoading
      }, t('button.create')))), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
        name: "email"
      }));
    }
  }));
};

exports.EmailFormSection = EmailFormSection;

var InvitationLinkSection = function InvitationLinkSection(_ref5) {
  var link = _ref5.link;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      disabled = _useState2[0],
      setDisabled = _useState2[1];

  function handleOnCopy() {
    setDisabled(true);
    setTimeout(function () {
      return setDisabled(false);
    }, 1500);
  }

  return /*#__PURE__*/_react["default"].createElement(Section, {
    label: t('settings.customDomain.newAccount.invitationLink')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    disable: true,
    className: "flex-1 font-semibold text-gray-medium text-sm py-2 px-4 mr-2 bg-secondary",
    value: link
  }), /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
    text: link,
    onCopy: handleOnCopy
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    className: "w-24 text-sm select-none"
  }, disabled ? t('button.copied') : t('button.copy')))));
};

exports.InvitationLinkSection = InvitationLinkSection;
//# sourceMappingURL=NewAccount.js.map